import React from 'react';
import {LandingSection} from './LandingSection';
import {CardList} from './Card';
import './Home.scss';
import HeroImage from './images/heroImage.svg';
import Blurb from '../../components/Blurb/Blurb';
import Blurbimg from './blurbImages/Blurb.svg';
import {MarketingCardSection} from "../../components/MarketingCardSection/MarketingCardSection";
import DedicatedTermsSvg from './images/sec2.svg';
import CustomSwSolutionImage from './images/customSwSolutionImage.svg';
import TestimonialSlider from "./TestimonialSlider";

export const Home = () => {
    return (
        <div className="main-container">
            <LandingSection
                image={HeroImage} title={'SUSTAINABLE SOFTWARE DEVELOPMENT'}
                description={'Develop world-class end to end customer software solutions for startups,transforming their aspirations into tangible realities. Embrace a novel approach that instills confidence.'}/>

            <MarketingCardSection
                image={DedicatedTermsSvg} title={'Dedicated teams'}
                description={'Unlock the power of focused collaboration with our dedicated teams. Tailored to meet your specific project needs, our expert professionals work seamlessly with your in-house team, fostering a unified and efficient workflow. With a shared vision, they operate as an extension of your organization, leveraging their skills from our dedicated workspace to ensure streamlined communication and accelerated project success. Experience the synergy of a dedicated team, committed to realizing your goals and bringing your projects to fruition.'}
            />
            <CardList/>
            <MarketingCardSection
                image={CustomSwSolutionImage} title={'Custom Software Solutions'}
                description={'Designing and developing custom software solutions tailored to your unique business needs, we provide cutting-edge technology to enhance efficiency and productivity. Our expert team collaborates closely with you to understand requirements, ensuring seamless integration with existing systems. From concept to deployment, we prioritize scalability, security, and user experience, delivering robust solutions that propel your business forward. Elevate your operations with our personalized approach to software development.'}

            />
<TestimonialSlider/>

        </div>
    );
};
